<template>
  <div class="park-detail" v-loading="loading">
    <div
      v-show="!$route.query.bool"
      style="margin-bottom: 15px; color: #057ee5; cursor: pointer"
      @click="$router.go(-1)"
    >
      <i class="el-icon-arrow-left"></i>
      <span> 返回列表</span>
    </div>
    <div class="park-detail-base">
      <div class="park-detail-base-img" ref="l1">
        <div class="swiper mySwiper2">
          <div class="swiper-wrapper">
            <div
              v-for="(item, index) in landFileInfo.pronounceImages"
              :key="index"
              class="swiper-slide"
            >
              <img
                :src="imgUrl + item.filePath"
                alt=""
                @click="handleLook(landFileInfo.pronounceImages, index)"
              />
              <div class="swiper-slide-title">{{ item.fileTitle }}</div>
            </div>
            <div
              v-for="(item, index) in landFileInfo.pronounceVideos"
              :key="item.targetId"
              class="swiper-slide"
            >
              <img
                :src="imgUrl + item.thumbnail"
                alt=""
                @click="playVideos(item)"
              />
              <div class="swiper-slide-icon el-icon-video-play"></div>
              <div class="swiper-slide-title">{{ item.fileTitle }}</div>
            </div>
          </div>
        </div>
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <el-image
              v-for="(item, index) in landFileInfo.pronounceImages"
              :src="imgUrl + item.filePath"
              :key="index"
              fit="cover"
              class="swiper-slide"
            ></el-image>
            <el-image
              v-for="(item, index) in landFileInfo.pronounceVideos"
              :key="item.targetId"
              :src="imgUrl + item.thumbnail"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
          <div class="swiper-button-prev m-swiper-button" />
          <div class="swiper-button-next m-swiper-button" />
        </div>
      </div>

      <div class="park-detail-base-content" ref="r1">
        <div class="park-detail-top-title1">
          <div class="park-detail-top-title1-l">
            {{ landDetailData.name || landDetailData.code }}
          </div>
          <div class="park-detail-top-title1-r">
            <div
              class="park-detail-top-title1-r-img"
              v-if="landDetailData.transaction != 2"
              @click="goMap"
            >
              <img src="../../assets/images/common/img10.png" alt="" />
            </div>
            <div
              class="park-detail-top-title1-r-img"
              v-if="
                landDetailData.panoramaVOS &&
                landDetailData.panoramaVOS.length === 1 &&
                landDetailData.panoramaVOS[0].panoramaUrl
              "
              @click="panorama(landDetailData.panoramaVOS[0].panoramaUrl)"
            >
              <img src="../../assets/images/common/img11.png" alt="" />
            </div>
            <div
              class="park-detail-top-title1-r-img"
              v-show="
                !landDetailData.panoramaVOS ||
                !landDetailData.panoramaVOS.length ||
                !landDetailData.panoramaVOS[0].panoramaUrl
              "
            >
              <img src="../../assets/images/common/img12.png" alt="" />
            </div>
            <div
              v-if="
                landDetailData.panoramaVOS &&
                landDetailData.panoramaVOS.length > 1
              "
            >
              <el-popover placement="bottom-start" width="100" trigger="click">
                <div class="panorama-box">
                  <div class="panorama-box-title">全景链接列表</div>
                  <div
                    v-for="(item, index) in landDetailData.panoramaVOS"
                    :key="index"
                    @click="panorama(item.panoramaUrl)"
                    class="panorama-box-li"
                  >
                    <div>{{ item.panoramaName }}</div>
                    <span class="el-icon-s-promotion"></span>
                  </div>
                </div>

                <div
                  slot="reference"
                  class="park-detail-top-title1-r-img"
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                  "
                >
                  <img src="../../assets/images/common/panorama1.png" alt="" />
                </div>
              </el-popover>
            </div>
          </div>
        </div>
        <div class="park-detail-top-title2">
          <div class="park-detail-top-title2-li">
            {{ landDetailData.countyName }}
          </div>
          <div
            class="park-detail-top-title2-li"
            style="cursor: pointer"
            v-show="landDetailData.parkCode"
            @click="goPark(landDetailData.parkId)"
          >
            {{ landDetailData.parkName }}
          </div>
          <div class="park-detail-top-title2-li">
            {{ landDetailData.area }}亩
          </div>
        </div>

        <div class="park-detail-top-title3">
          <div class="park-detail-top-title3-li3">
            <div>联系人： {{ landDetailData.person }}</div>
            <div>联系电话：{{ landDetailData.phone }}</div>
          </div>
        </div>
        <div class="park-detail-top-title4">
          <div class="park-detail-top-title4-li">
            <div class="park-detail-top-title4-li-t">行政区划</div>
            <div class="park-detail-top-title4-li-b">
              {{ landDetailData.countyName ? landDetailData.countyName : "--" }}
            </div>
          </div>
          <div class="park-detail-top-title4-li">
            <div class="park-detail-top-title4-li-t">
              {{ landDetailData.supplyPeriod == 4 ? "规划用途" : "土地用途" }}
            </div>
            <div class="park-detail-top-title4-li-b">
              {{ landDetailData.typeName ? landDetailData.typeName : "--" }}
            </div>
          </div>
          <div
            class="park-detail-top-title4-li"
            v-show="landDetailData.supplyPeriod != 4"
          >
            <div class="park-detail-top-title4-li-t">出让年限</div>
            <div class="park-detail-top-title4-li-b">
              {{
                landDetailData.transferDate
                  ? landDetailData.transferDate + "年"
                  : "--"
              }}
            </div>
          </div>

          <div class="park-detail-top-title4-li">
            <div class="park-detail-top-title4-li-t">面积</div>
            <div class="park-detail-top-title4-li-b">
              {{ landDetailData.area ? landDetailData.area : "--" }}亩
            </div>
          </div>
          <div
            class="park-detail-top-title4-li"
            v-show="landDetailData.supplyPeriod != 4"
          >
            <div class="park-detail-top-title4-li-t">行业类型</div>
            <div class="park-detail-top-title4-li-b">
              <span>
                {{
                  landDetailData.industryTypeName
                    ? landDetailData.industryTypeName
                    : "--"
                }}</span
              >
            </div>
          </div>
          <div
            class="park-detail-top-title4-li"
            v-show="landDetailData.supplyPeriod != 4"
          >
            <div class="park-detail-top-btn" @click="moreDetail">更多详情</div>
          </div>
        </div>
        <div class="park-detail-top-title4">
          <div class="park-detail-top-title4-li-t">土地坐落</div>
          <div class="park-detail-top-title4-li-b">
            {{ landDetailData.location ? landDetailData.location : "--" }}
          </div>
        </div>
        <div class="park-detail-top-title5">
          <div
            class="park-detail-top-title5-span title5-span1"
            v-if="landDetailData.isStandard"
          >
            标准地
          </div>
          <div
            class="park-detail-top-title5-span title5-span2"
            v-if="
              landDetailData.infrastructureList &&
              landDetailData.infrastructureList.length > 3
            "
          >
            {{ landDetailData.infrastructureName }}
          </div>
          <el-popover placement="top-start" width="200" trigger="hover">
            <div>
              <span v-show="landDetailData.supplyPeriod == 1">
                经国务院或省政府批准，达到“净地”标准，已发布出让公告的地块或拟于三个月内出让（含已纳入住宅用地拟出让清单）的地块。</span
              >
              <span v-show="landDetailData.supplyPeriod == 3">
                经国务院或省政府批准，拟于三个月后出让的地块。</span
              >
              <span v-show="landDetailData.supplyPeriod == 4">
                符合国土空间规划、控制性详细规划，满足用地报批要求，未来可用于项目建设的用地。</span
              >
            </div>
            <div
              slot="reference"
              v-show="landDetailData.supplyPeriod"
              style="cursor: pointer"
              :class="
                landDetailData.supplyPeriod == 1
                  ? 'available'
                  : landDetailData.supplyPeriod == 3
                  ? 'availableNear'
                  : landDetailData.supplyPeriod == 4
                  ? 'availability'
                  : ''
              "
              class="park-detail-top-title3-li1 park-detail-top-title3-span1"
            >
              <img
                style="width: 15px; margin-right: 5px"
                :src="
                  landDetailData.supplyPeriod == 1
                    ? img01
                    : landDetailData.supplyPeriod == 3
                    ? img02
                    : landDetailData.supplyPeriod == 4
                    ? img03
                    : ''
                "
                alt=""
              />
              {{
                landDetailData.supplyPeriod == 1
                  ? "立等可供"
                  : landDetailData.supplyPeriod == 3
                  ? "计划可供"
                  : landDetailData.supplyPeriod == 4
                  ? "规划可用"
                  : ""
              }}
            </div>
          </el-popover>

          <!-- <el-tooltip class="item" effect="dark" placement="bottom" :open-delay="2000">
            <div slot="content" style="width: 140px">
              <span v-show="landDetailData.supplyPeriod == 1">
                经国务院或省政府批准，达到“净地”标准，计划一个月内出让或已发布出让公告的地块。</span>
              <span v-show="landDetailData.supplyPeriod == 2">
                经国务院或省政府批准，达到“净地”标准，计划三个月内出让或已纳入住宅用地拟出让清单的地块。</span>
              <span v-show="landDetailData.supplyPeriod == 3">
                经国务院或省政府批准，或者符合规划和办理农用地转用征收要求，近一年内可以完善相关手续并出让的地块。</span>
            </div>
            <div v-show="landDetailData.supplyPeriod" :class="landDetailData.supplyPeriod == 1
                ? 'available'
                : landDetailData.supplyPeriod == 2
                  ? 'availableNear'
                  : landDetailData.supplyPeriod == 3
                    ? 'availability'
                    : ''
              " class="park-detail-top-title3-li1 park-detail-top-title3-span1">
              <img style="width: 15px; margin-right: 5px" :src="landDetailData.supplyPeriod == 1
                  ? img01
                  : landDetailData.supplyPeriod == 2
                    ? img02
                    : landDetailData.supplyPeriod == 3
                      ? img03
                      : ''
                " alt="" />
              {{
                landDetailData.supplyPeriod == 1
                ? "立等可供"
                : landDetailData.supplyPeriod == 2
                  ? "近期可供"
                  : landDetailData.supplyPeriod == 3
                    ? "计划可供"
                    : ""
              }}
            </div>
          </el-tooltip> -->
          <div
            class="park-detail-top-title3-li2"
            style="background: #69ba01"
            v-if="landDetailData.plotRate"
          >
            <div class="park-detail-top-title3-li2-span1">
              {{ landDetailData.plotRate }}
            </div>
          </div>
          <div
            class="park-detail-top-title3-li2"
            style="background: #2090ff"
            v-if="landDetailData.isReserve"
          >
            储备土地
          </div>
        </div>
        <div class="disclaimer">
          <div>
            <span>*</span>
            <span>地块相关信息仅供参考，如有疑问请咨询联系人</span>
          </div>

          <div style="display: flex" v-if="landDetailData.transaction != '2'">
            <!-- v-if="
                !crggHtml &&
                isCollect != null &&
                isCollect == false &&
                !transferAnnounceStatus &&
                landDetailData.transaction != '2'
              " -->
            <div
              class="disclaimer-btn disclaimer-btn1"
              v-if="
                isCollect != null &&
                isCollect == false &&
                landDetailData.approvalStatus == 3
              "
              @click="addIntention"
            >
              我有意向
            </div>
            <div class="disclaimer-btn disclaimer-btn3" v-if="isCollect">
              已加入意向列表
            </div>
            <!-- <div class="disclaimer-btn disclaimer-btn2" v-if="crggHtml" @click="lookIntention">
              我要买地
            </div> -->
            <!-- <el-popconfirm
              v-if="
                this.token &&
                transferAnnounceStatus &&
                landDetailData.transaction != '2'
              "
              title="当前地块已成功加入意向列表，是否跳转到云南省公共资源交易平台参与公开竞买"
              @confirm="lookIntention(true)"
              @cancel="lookIntention(false)"
            >
              <el-button class="disclaimer-btn disclaimer-btn2" slot="reference"
                >我要买地</el-button
              >
            </el-popconfirm> -->
            <!--  v-if="
                !this.token &&
                transferAnnounceStatus &&
                landDetailData.transaction != '2'
              " 
               @click="$eventBus.emit('isToken', false)"-->
            <el-button
              v-if="transferAnnounceStatus && landDetailData.transaction != '2'"
              class="disclaimer-btn disclaimer-btn2"
              @click="lookIntention(true)"
            >
              我要买地
            </el-button>
            <!-- <div class="disclaimer-icon" v-if="isCollect">
              <i class="el-icon-star-on"></i>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <el-tabs type="border-card" v-model="activeName" class="content-tab">
      <el-tab-pane label="地块简介" name="地块简介">
        <div class="other-box-l-li1" v-if="landDetailData.synopsis">
          <div
            style="padding: 10px 0; line-height: 25px; font-size: 14px"
            v-html="landDetailData.synopsis"
          ></div>
        </div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
        <!-- <div class="other-box-l-li1" v-else>暂无数据</div> -->
      </el-tab-pane>
      <el-tab-pane label="所属片区" name="所属片区">
        <div v-if="landDetailData.sliceId" class="other-box-title">
          {{ landDetailData.sliceVO.name }}
        </div>
        <div class="other-box-l-li-p-box" v-if="landDetailData.sliceId">
          <div
            class="other-box-l-li-p-content scrollbar-definition"
            style=""
            v-html="landDetailData.sliceVO.content"
          ></div>
          <div class="other-box-l-li-p-gd">
            <div class="other-box-l-li-p-gd-t">
              <div
                v-show="
                  landDetailData.sliceVO.pronounceImages &&
                  landDetailData.sliceVO.pronounceImages.length
                "
                class="other-box-l-li-p-gd-t-img"
                v-for="(item, index) in landDetailData.sliceVO.pronounceImages"
                :key="index"
                ref=" "
                @click="
                  handleLook(landDetailData.sliceVO.pronounceImages, index)
                "
              >
                <img :src="imgUrl + item.filePath" alt="" />
              </div>
            </div>
            <div
              class="other-box-l-li-p-gd-b"
              v-if="
                landDetailData.sliceVO &&
                landDetailData.sliceVO.pronounceVideos &&
                landDetailData.sliceVO.pronounceVideos.length
              "
            >
              <img
                :src="
                  imgUrl + landDetailData.sliceVO.pronounceVideos[0].thumbnail
                "
                alt=""
              />
              <div
                class="other-box-l-li-p-gd-b-icon el-icon-video-play"
                @click="playVideos(landDetailData.sliceVO.pronounceVideos[0])"
              ></div>
            </div>
          </div>
        </div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
        <!-- <div class="other-box-l-li-p-box" v-else>暂无数据</div> -->
      </el-tab-pane>
      <el-tab-pane label="招商政策" name="招商政策">
        <div class="other-box-l-li1" v-if="policyInfos && policyInfos.length">
          <div class="other-box-l-li-box">
            <div
              class="other-box-l-li-box-li"
              v-for="(item, index) in policyInfos"
              :key="index"
              v-show="policyInfos && policyInfos.length"
              @click="
                $router.push({
                  name: 'rtfPreview',
                  params: item,
                })
              "
            >
              <div class="other-box-l-li-box-li-l">
                <i class="iconfont icon-ico_arrowright iconfont-color"></i>
              </div>
              <div class="other-box-l-li-box-li-r">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="基础设施" name="基础设施">
        <div
          class="other-box-l-li1"
          v-if="
            landDetailData.infrastructureList &&
            landDetailData.infrastructureList.length
          "
        >
          <!-- <div class="other-box-l-li-text">基础设施</div> -->
          <div class="other-box-r-box">
            <div
              class="other-box-r-box-li"
              v-for="(item, index) in landDetailData.infrastructureArr"
              :key="index"
            >
              <div class="other-box-r-box-li-t">
                <img :src="item.img" alt="" />
              </div>
              <div class="other-box-r-box-li-b">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div
            class="other-box-r-content"
            v-if="landDetailData.infrastructureRemark"
          >
            <span class="other-box-r-content-tag el-icon-warning"></span>
            <span
              >备注：<span v-html="landDetailData.infrastructureRemark"></span>
            </span>
          </div>
        </div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable1.png" alt="" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="周边概况" name="周边概况">
        <div class="other-box-l-li1">
          <div class="traffic-location">
            <div class="traffic-location-top">
              <div class="traffic-location-top-right">
                <div
                  v-for="(item, index) in typeList"
                  :key="index"
                  :class="[
                    'traffic-location-top-right-li',
                    factorIndex == item.value ? 'right-li-active' : '',
                  ]"
                  @click="
                    factorIndex = item.value;
                    changeFactorIndex(item.value);
                  "
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div
              class="traffic-location-map"
              v-if="
                activeName == '周边概况' && landDetailData.defaultLevel != null
              "
            >
              <tz-map
                ref="map"
                :position="position"
                container="mapView"
                :zoom="landDetailData.defaultLevel"
                mw="100%"
                mh="100%"
                :maxZoom="18"
              >
                <tz-toggle-map
                  :base-list="configList"
                  :is-note="true"
                  :index="1"
                  :offset="{ right: '5px', bottom: '5px' }"
                />
                <mapImage></mapImage>
              </tz-map>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="宣传资料"
        name="宣传资料"
        v-if="landFileInfo.pronounceFiles?.length"
      >
        <div>
          <div
            v-if="landFileInfo.pronounceFiles?.length"
            class="park-detail-info-investment-file"
          >
            <div
              class="park-detail-info-investment-file-li"
              v-for="(item, index) of landFileInfo.pronounceFiles"
              :key="index"
              @click="previewOrDownFile(item)"
            >
              <!--                <div><img :src="getFileIconUrl(item.suffix)" alt="" /></div>-->
              <div class="park-detail-info-investment-image-item-title">
                {{ item.fileTitle }}
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="出让公告" name="出让公告" v-if="crggHtml">
        <div v-if="crggHtml" v-html="crggHtml"></div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="成交公示" name="出让公示" v-if="crgsHtml">
        <div v-if="crgsHtml" v-html="crgsHtml"></div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
      </el-tab-pane>
    </el-tabs>

    <video-dialog
      :visible="playVideo.show"
      :videoSrc="playVideo.src"
      :videoTitle="playVideo.title"
      @onCloseVideo="playVideo.show = false"
    />
    <el-image-viewer
      v-if="previewImage.show"
      :url-list="previewImage.urlList"
      :initial-index="previewImage.index"
      :on-close="() => (previewImage.show = false)"
      style="z-index: 9999"
    />
    <el-dialog width="800px" title="详细信息" :visible.sync="detailDialogShow">
      <div class="detail-pop-content-box">
        <div class="detail-pop-content-box-title">
          <div><img src="../../assets/images/common/title1.png" alt="" /></div>
          <div class="detail-pop-content-box-title-span">基本信息</div>
        </div>
        <el-row>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 地块名称:</el-col>
            <el-col :span="16">
              {{ landDetailData.name }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 宗地编号:</el-col>
            <el-col :span="16">
              {{ landDetailData.code ? landDetailData.code : "--" }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 行政区划:</el-col>
            <el-col :span="16">
              {{ landDetailData.countyName ? landDetailData.countyName : "--" }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 地块面积:</el-col>
            <el-col :span="16">
              {{ landDetailData.area ? landDetailData.area : "--" }}亩
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 土地坐落:</el-col>
            <el-col :span="16">
              {{ landDetailData.location ? landDetailData.location : "--" }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 所属片区:</el-col>
            <el-col :span="16">
              {{
                landDetailData.sliceVO && landDetailData.sliceVO.name
                  ? landDetailData.sliceVO.name
                  : "无"
              }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 土地用途:</el-col>
            <el-col :span="16">
              {{ landDetailData.typeName ? landDetailData.typeName : "--" }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 出让年限:</el-col>
            <el-col :span="16">
              {{
                landDetailData.transferDate
                  ? landDetailData.transferDate
                  : "--"
              }}年
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 行业类型:</el-col>
            <el-col
              :span="16"
              style="display: flex; align-items: center; flex-wrap: wrap"
            >
              {{
                landDetailData.industryTypeName
                  ? landDetailData.industryTypeName
                  : "--"
              }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 土地等级:</el-col>
            <el-col :span="16">
              {{
                landDetailData.landLevelName
                  ? landDetailData.landLevelName
                  : "--"
              }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 基础设施:</el-col>
            <el-col :span="16">
              {{
                landDetailData.infrastructureName
                  ? landDetailData.infrastructureName
                  : "--"
              }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 净地:</el-col>
            <el-col :span="16">
              {{ landDetailData.cleanLand == 1 ? "是" : "否" }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 是否标准地:</el-col>
            <el-col :span="16">
              {{ landDetailData.isStandard ? "是" : "否" }}
            </el-col>
          </el-col>
        </el-row>
        <div class="detail-pop-content-box-title">
          <div><img src="../../assets/images/common/title1.png" alt="" /></div>
          <div class="detail-pop-content-box-title-span">规划信息</div>
        </div>
        <el-row>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 容积率:</el-col>
            <el-col :span="16">
              {{
                landDetailData.plotRate && landDetailData.plotRate != "-1"
                  ? landDetailData.plotRate
                  : "--"
              }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 绿地率:</el-col>
            <el-col :span="16">
              {{
                landDetailData.greeningRate &&
                landDetailData.greeningRate != "-1"
                  ? landDetailData.greeningRate
                  : "--"
              }}%
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 建筑密度:</el-col>
            <el-col :span="16">
              {{
                landDetailData.buildingDensity &&
                landDetailData.buildingDensity != "-1"
                  ? landDetailData.buildingDensity
                  : "--"
              }}
            </el-col>
          </el-col>
          <el-col :span="12" class="detail-pop-content-box-col">
            <el-col :span="6"> 建筑限高:</el-col>
            <el-col :span="16">
              {{
                landDetailData.buildingHeight &&
                landDetailData.buildingHeight != "-1"
                  ? landDetailData.buildingHeight
                  : "--"
              }}米
            </el-col>
          </el-col>
        </el-row>
        <div class="detail-pop-content-box-title">
          <div><img src="../../assets/images/common/title1.png" alt="" /></div>
          <div class="detail-pop-content-box-title-span">
            公示地价
            <!-- <span>*以实际招拍挂价格为准</span> -->
          </div>
        </div>
        <el-row>
          <el-col
            :span="12"
            class="detail-pop-content-box-col"
            v-if="landDetailData.radio == 0"
          >
            <el-col :span="6"> 参考价格:</el-col>
            <el-col :span="16">
              {{ landDetailData.price ? landDetailData.price + "万元" : "--" }}
            </el-col>
          </el-col>
          <!-- <el-col v-if="landDetailData.radio == 2">以招拍挂价格为准</el-col> -->
        </el-row>
        <el-row>
          <el-col :span="12" class="detail-pop-content-box-col col-box">
            <div>城镇基准地价：</div>
            <div style="margin-left: 10px">
              {{ priceInfo.czjzdj }}
            </div>
          </el-col>
          <el-col
            :span="12"
            class="detail-pop-content-box-col col-box"
            v-if="priceInfo.bzdj != '--元/㎡'"
          >
            <div>标定地价：</div>
            <div style="margin-left: 10px">
              {{ priceInfo.bzdj }}
            </div>
          </el-col>
          <el-col
            :span="12"
            class="detail-pop-content-box-col col-box"
            v-if="priceInfo.jtjsyddj != '--元/㎡'"
          >
            <div>集休建设用地地价：</div>
            <div style="margin-left: 10px">
              {{ priceInfo.jtjsyddj }}
            </div>
          </el-col>
          <el-col
            :span="12"
            class="detail-pop-content-box-col col-box"
            v-if="
              priceInfo.csdjdtjc.spz1 ||
              priceInfo.csdjdtjc.spz2 ||
              priceInfo.csdjdtjc.spz3 ||
              priceInfo.csdjdtjc.spz4
            "
          >
            <div class="col-l">城市地价动态监测：</div>
            <div class="col-r">
              <div>
                一季度：{{
                  priceInfo.csdjdtjc.spz1 ? priceInfo.csdjdtjc.spz1 : "--"
                }}元/㎡
              </div>
              <div>
                二季度：{{
                  priceInfo.csdjdtjc.spz2 ? priceInfo.csdjdtjc.spz2 : "--"
                }}元/㎡
              </div>
              <div>
                三季度：{{
                  priceInfo.csdjdtjc.spz3 ? priceInfo.csdjdtjc.spz3 : "--"
                }}元/㎡
              </div>
              <div>
                四季度：{{
                  priceInfo.csdjdtjc.spz4 ? priceInfo.csdjdtjc.spz4 : "--"
                }}元/㎡
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <a :href="landUrl" target="_blank"
            >地价信息来自云南省公示地价查询平台</a
          >
        </el-row>
        <!-- <el-row>
          <el-col
            :span="12"
            class="detail-pop-content-box-col"
            v-for="item in priceData"
            v-show="item.priceType !== '城市地价动态监测'"
            style="display: flex"
          >
            <div>{{ item.priceType }}-{{ item.landType }}：</div>
            <div style="margin-left: 10px">
              {{ item.price ? item.price : "--" }}元/㎡
            </div>
          </el-col>
          <el-col
            :span="24"
            class="detail-pop-content-box-col"
            v-for="item in priceData"
            v-show="item.priceType === '城市地价动态监测'"
            style="display: flex; line-height: 22px"
          >
            <div>{{ item.priceType }}-{{ item.landType }}：</div>
            <div>
              <span>一季度：{{ item.spz1 ? item.spz1 : "--" }}元/㎡</span>
              <span>二季度：{{ item.spz2 ? item.spz2 : "--" }}元/㎡</span>
              <span>三季度：{{ item.spz3 ? item.spz3 : "--" }}元/㎡</span>
              <span>四季度：{{ item.spz4 ? item.spz4 : "--" }}元/㎡</span>
            </div>
          </el-col>
        </el-row> -->

        <!-- <div style="color: red; font-size: 12px" v-if="!showPrice">
          未从地价公示系统获取到相关地价信息!
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mapImage from "@/components/mapImage";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "quill-better-table/dist/quill-better-table.css";
import Swiper from "swiper/swiper-bundle.min";
import img1 from "@/assets/images/ldkg-activate.png";
import img2 from "@/assets/images/jhkg-activate.png";
import img3 from "@/assets/images/ghkg-activate.png";
import "swiper/swiper-bundle.min.css";
import VideoDialog from "@/components/currency/videoDialog";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import LandPlace from "@/views/land/components/LandPlace";
import LandPopularPush from "@/views/land/components/LandPopularPush";
import {
  getLandInfoTwo,
  getPicture,
  getShp,
  getLandInfoLogin,
  landPriceData,
  policyInfo,
  transferAnnouncement,
  plotPublicity,
  addFavorite,
  confirmFavorite,
} from "@/api/setting/investment";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom.js";
import mapEvent from "@/map/mapEvent.js";
import intention from "@/components/currency/intention";
/**
 * @Description 地块详情
 */
export default {
  name: "LandDetail",
  components: {
    LandPopularPush,
    LandPlace,
    ElImageViewer,
    VideoDialog,
    intention,
    mapImage,
  },
  data() {
    return {
      loading: false,
      landUrl: "",
      isRefresh: 0,
      userInfo: {
        sysUser: {
          userId: "",
        },
      },
      img01: img1,
      img02: img2,
      img03: img3,
      mapEvents: null,
      areaShow: false, //是否显示所属片区
      detailDialogShow: false, //展示片区弹窗
      position: [100.264162, 25.615269],
      configList: mapConfig.configList,
      landDetailData: {
        // sliceId: null,
      }, //详情信息
      landFileInfo: {}, //文件信息
      fileShp: {}, //图形数据
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      playVideo: {
        show: false,
        src: undefined,
        title: undefined,
      },
      previewImage: {
        show: false,
        urlList: [],
        index: 0,
      },
      infrastructureConfigList: [
        {
          value: "1",
          label: "土地平整",
        },
        {
          value: "2",
          label: "通雨水管线",
        },
        {
          value: "3",
          label: "通污水管线",
        },
        {
          value: "4",
          label: "通电信管道及电缆",
        },
        {
          value: "5",
          label: " 通热力管线",
        },
        {
          value: "6",
          label: "通电力管线",
        },
        {
          value: "7",
          label: "通自来水管线",
        },
        {
          value: "8",
          label: "通天然气管线",
        },
        {
          value: "9",
          label: "通有线电视线光缆",
        },
        {
          value: "10",
          label: "通道路",
        },
      ],
      infrastructureArr: [
        {
          name: "土地平整",
          img: require("@/assets/images/common/land.png"),
          id: "1",
        },
        {
          name: "道路",
          img: require("@/assets/images/common/road.png"),
          id: "10",
        },
        {
          name: "给水",
          img: require("@/assets/images/common/water.png"),
          id: "7",
        },
        {
          name: "雨水",
          img: require("@/assets/images/common/rain.png"),
          id: "2",
        },
        {
          name: "污水",
          img: require("@/assets/images/common/sewage.png"),
          id: "3",
        },
        {
          name: "天然气",
          img: require("@/assets/images/common/natural_gas.png"),
          id: "8",
        },
        {
          name: "供电",
          img: require("@/assets/images/common/power.png"),
          id: "6",
        },
        {
          name: "宽带",
          img: require("@/assets/images/common/broadband.png"),
          id: "9",
        },
        {
          name: "通讯",
          img: require("@/assets/images/common/communication.png"),
          id: "4",
        },
        {
          name: "供暖",
          img: require("@/assets/images/common/gn.png"),
          id: "5",
        },
      ], //基础设施
      policyList: [
        { title: "关于扩大对外开放积极利用外资若干措施的通知" },
        { title: "强化政策完善措施进一步提高对外开放开发水平" },
        { title: "关于进一步优化提升营商环境全面打造国际一流创新创业" },
        { title: "关于扩大对外开放积极利用外资水平的意见" },
        { title: "鼓励跨国公司总部型机构发展专项资金使用和管理方法" },
        { title: "关于扩大对外开放积极利用外资水平的意见" },
      ],
      markFontColor: {
        type: String,
        default: "#000",
      },

      factorIndex: null, //要素类型下标
      factorList: [], //要素列表
      typeList: [
        {
          name: "全部",
          value: 0,
        },
        {
          name: "行政中心",
          value: 1,
          img: require("@/assets/images/factor/jiguandanwei.png"),
        },
        {
          name: "企业",
          value: 2,
          img: require("@/assets/images/factor/qiye.png"),
        },
        {
          name: "医疗",
          value: 3,
          img: require("@/assets/images/factor/yiyuan1.png"),
        },
        {
          name: "教育",
          value: 4,
          img: require("@/assets/images/factor/xuexiao.png"),
        },
        {
          name: "生活",
          value: 5,
          img: require("@/assets/images/factor/shequchaoshi.png"),
        },
        {
          name: "交通",
          value: 6,
          img: require("@/assets/images/factor/jiaotong.png"),
        },
        {
          name: "其他",
          value: 7,
          img: require("@/assets/images/factor/qitarukudanmingxi.png"),
        },
      ],
      activeName: "地块简介",
      activeName1: "出让公告",
      developData: "展开更多",
      developData1: "展开更多",
      iconEdit: "el-icon-arrow-down",
      iconEdit1: "el-icon-arrow-down",
      listData: {},
      priceData: [],
      price: [],
      // 图形文件的经纬度数据
      properties: {},
      showPrice: false,
      policyInfos: [], //政策列表
      priceInfo: {
        czjzdj: "--元/㎡",
        bzdj: "--元/㎡",
        jtjsyddj: "--元/㎡",
        csdjdtjc: {},
      },
      crggHtml: "", //出让公告
      crgsHtml: "", //成交公示
      token: "",
      isCollect: null, //是否收藏
      isShowCollect: false, //是否显示收藏
      transferAnnounceStatus: false,
    };
  },
  created() {
    //this.landDetailData = JSON.parse(sessionStorage.getItem(this.$route.name));
  },
  watch: {
    activeName: function (val) {
      if (val == "周边概况") {
        this.$nextTick(() => {
          this.mapView = this.$refs.map.tzApi;
          this.mapView.map.addInteraction(new DoubleClickZoom());
          this.getShpInfo(this.landDetailData.id);
          systemConfig.mapApi = this.mapView;
          // this.mapEvents = new mapEvent();
          // this.mapEvents.mapEventDbClick("mapView");
          let code = "";
          let param = this.convert(this.configList.mapconfig[1].args);
          code = `this.mapView.${this.configList[1].mapconfig.func}(${param})`;
          eval(code);
          if (this.configList[1].note.openSymbol) {
            this.addLayer(this.configList[1].note.mapconfig);
          }
          this.factorIndex = 0;
          this.changeFactorIndex(0);
        });
      }
    },

    factorList: {
      deep: true,
      handler(val, oldVal) {
        if (oldVal && oldVal.length) {
          oldVal.forEach((item) => {
            let str = "type" + item.type + "_" + item.id;
            this.mapView.removeVectorFeatureById(str);
          });
        }
        if (val && val.length) {
          val.forEach((item) => {
            let coordinate = [item.centerX, item.centerY];
            let img = this.typeList[item.type].img;
            this.draw(
              coordinate,
              img,
              item.name,
              "type" + item.type + "_" + item.id
            );
          });
        }
      },
    },
    $route(to) {
      if (to.path == "/land/detail") {
        location.reload(true);
        // console.log("第二次进来");
      }
    },
  },
  activated() {
    // let id = this.$route.query.id;
    // this.getCompanyList();
    // this.getDetail(id);
    // this.getPictureInfo(id);
    //
    // this.$nextTick(() => {
    //   this.setSwiper();
    // });
  },
  mounted() {
    this.token = sessionStorage.getItem("access_token")
      ? sessionStorage.getItem("access_token")
      : "";
    let id = this.$route.query.id;
    this.getDetail(id);
    this.getPictureInfo(id);
    // this. getLandPrice()
    //监听注册事件
    this.$eventBus.on("isDetailRefresh", (val) => {
      if (val) {
        this.getIsCollect(id);
      } else {
        //退出登录
        this.isCollect = false;
      }
    });
    if (this.token) {
      this.getIsCollect(id);
    } else {
      this.isCollect = false;
    }

    this.$nextTick(() => {
      this.setSwiper();
    });
    this.$eventBus.on("isLogin", () => {
      this.token = sessionStorage.getItem("access_token")
        ? sessionStorage.getItem("access_token")
        : "";
    });
    // this.getLandInfoLoginData()
  },
  methods: {
    //是否收藏
    getIsCollect(id) {
      console.log(id, "id");
      confirmFavorite(id).then((res) => {
        if (res.data.success) {
          this.isCollect = res.data.data;
        } else {
          this.isCollect = false;
        }
      });
    },
    //我要买地
    lookIntention(bool) {
      // window.open("http://ggzy.yn.gov.cn/#/homePage");
      this.token = sessionStorage.getItem("access_token");
      if (!this.token) {
        this.$eventBus.emit("isToken", false);
        return;
      }
      if (bool) {
        window.open("https://ggzy.yn.gov.cn/yn-tender/index.html#/login");
        this.addIntention();
      } else {
        this.addIntention();
      }
    },
    //添加意向地块
    addIntention() {
      this.loading = true;
      this.token = sessionStorage.getItem("access_token");
      if (!this.token) {
        // this.$message.error("请先登录/注册");
        this.$eventBus.emit("isToken", false);
        this.loading = false;
        return;
      }

      addFavorite({
        parcelId: this.landDetailData.id,
      }).then((res) => {
        this.loading = false;
        this.isRefresh++;
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.$eventBus.emit("isRefresh", this.isRefresh);
          this.getIsCollect(this.landDetailData.id);
        } else {
          this.$message.error(res.data.msg);
          this.$eventBus.emit("isRefresh", this.isRefresh);
        }
      });
    },
    //添加影像注记
    addLayer(conf) {
      let code,
        func = conf.func,
        param = this.convert(conf.args);
      let that = this;
      code = `this.mapView.${func}(${param})`;
      eval(code);
      console.log(code, "code");
    },
    moreDetail() {
      this.detailDialogShow = true;
      getShp(this.landDetailData.id).then((res) => {
        if (res.data.success) {
          let data = res.data.data;

          this.getLandPrice(this.landDetailData, data);
        }
      });
    },
    // 获取地价
    getLandPrice(landDetailData, data) {
      if (!!data && !!data.shapeInfo && !!landDetailData.type) {
        let { lng, lat } = data.shapeInfo[0];
        let params = {
          tdyt: parseInt(landDetailData.type),
          lng: lng,
          lat: lat,
        };
        landPriceData(params).then((res) => {
          if (res.data.success) {
            let data = JSON.parse(res.data.data);
            // this.priceInfo = {
            //   czjzdj: "--元/㎡",
            //   bzdj: "元/㎡",
            //   jtjsyddj: "元/㎡",
            //   csdjdtjc: {},
            // };

            data.data.forEach((item) => {
              if (item.priceType == "标定地价") {
                this.priceInfo.bzdj = `(${item.landType}) ${
                  item.price ? item.price : "--"
                } 元/㎡`;
              }
              if (item.priceType == "城镇基准地价") {
                this.priceInfo.czjzdj = `(${item.landType}) ${
                  item.price ? item.price : "--"
                } 元/㎡`;
              }
              if (item.priceType == "集休建设用地地价") {
                this.priceInfo.jtjsyddj = `(${item.landType}) ${
                  item.price ? item.price : "--"
                } 元/㎡`;
              }
              if (item.priceType == "城市地价动态监测") {
                this.priceInfo.csdjdtjc = item;
              }
            });

            if (data.data.length > 0) {
              this.showPrice = true;
              this.priceData = data.data;
            } else {
              this.showPrice = false;
            }
          }
        });
      }
    },
    openAnnounce() {
      if (!!this.listData.transferAnnounceUrl) {
        window.open(this.listData.transferAnnounceUrl);
      } else if (!!this.landFileInfo.transferAnnounceFile) {
        let url = `${this.imgUrl}${this.landFileInfo.transferAnnounceFile[0].filePath}`;
        window.open(url);
      }
    },
    openPublicity() {
      if (!!this.listData.plotPublicityUrl) {
        window.open(this.listData.plotPublicityUrl);
      } else if (!!this.landFileInfo.plotPublicityFile) {
        let url = `${this.imgUrl}${this.landFileInfo.plotPublicityFile[0].filePath}`;
        window.open(url);
      }
    },
    // getLandInfoLoginData
    develop() {
      let dom = document.querySelector("#dom");
      if (!!dom) {
        if (this.developData1 === "展开更多") {
          this.developData1 = "收起";
          this.iconEdit1 = "el-icon-arrow-up";
          dom.style.height = "100%";
        } else {
          this.developData1 = "展开更多";
          this.iconEdit1 = "el-icon-arrow-down";
          dom.style.height = "350px";
        }
      }
    },
    develop2() {
      let dom = document.querySelector("#dom2");
      if (!!dom) {
        if (this.developData === "展开更多") {
          this.developData = "收起";
          this.iconEdit = "el-icon-arrow-up";
          dom.style.height = "100%";
        } else {
          this.developData = "展开更多";
          this.iconEdit = "el-icon-arrow-down";
          dom.style.height = "350px";
        }
      }
    },
    //周边企业打点
    draw(coordinate, img, name, id) {
      this.mapView.addVectorPoint(
        coordinate,
        name,
        img,
        { id: id },
        "#000",
        "#fff",
        20,
        [0.5, -27],
        undefined,
        "13px"
      );
    },

    getShpInfo(id) {
      getShp(id).then((res) => {
        if (res.data.success) {
          this.fileShp = res.data.data;
          let center = this.mapView.getPolygonCenter(
            this.fileShp.shapeInfo[0].geom.coordinates[0]
          );
          // this.mapView.addVectorPoint(
          //   center,
          //   this.landDetailData.name,
          //   require("@/assets/leadCockpitImage/land.png"),
          //   undefined,
          //   "#007eff",
          //   "#fff",
          //   0,
          //   [0.5, 0.5]
          // );
          this.fileShp.shapeInfo.forEach((item) => {
            this.mapView.addVectorMultiPolygon(
              item.geom.coordinates,
              this.landDetailData.name,
              { id: "kfq_layer" },
              "#04ebf0",
              "rgba(0,0,0,0)",
              "#007eff",
              "#fff",
              undefined,
              undefined,
              4
            );
          });

          // this.mapView.flyTo(center);
          let extent = this.mapView.getMultiPolygonExtent(
            this.fileShp.shapeInfo[0].geom.coordinates
          );
          this.mapView.zoomToExtent(extent[0], extent[1], extent[2], extent[3]);
        }
      });
    },
    getPictureInfo(id) {
      getPicture(id).then((res) => {
        if (res.data.success) {
          this.landFileInfo = res.data.data;
        }
      });
    },
    //切换要素类型
    changeFactorIndex(index) {
      if (index == 0) {
        this.factorList = this.landDetailData.surroundOverviewVos
          ? this.landDetailData.surroundOverviewVos
          : [];
      } else {
        if (this.landDetailData.surroundingMaps) {
          this.factorList = this.landDetailData.surroundingMaps["type_" + index]
            ? this.landDetailData.surroundingMaps["type_" + index]
            : [];
        }
      }
    },
    getDetail(id) {
      getLandInfoTwo(id)
        .then((res) => {
          if (res.data.success) {
            let data = res.data.data;
            this.transferAnnounceStatus = data.transferAnnounceStatus;
            this.landUrl = `http://182.245.146.166:53335/ynsgsdjcx/home?priceType=czjzdj&coord=${data.lng},${data.lat}`;
            console.log(this.landUrl, " this.landUrl");
            let arr = [];
            if (data.infrastructureList.length) {
              data.infrastructureList.forEach((item, index) => {
                let Iindex = this.infrastructureArr.findIndex(
                  (Iitem) => Iitem.id == item
                );
                if (Iindex != -1) {
                  arr.push(this.infrastructureArr[Iindex]);
                }
                let obj = this.infrastructureConfigList.find(
                  (inItem) => inItem.value == item
                );
              });
            }
            this.$set(data, "infrastructureArr", arr);
            // 获取地价
            this.landDetailData = data;
            // console.log(this.landDetailData.infrastructureList.length);
            this.listData = data;
            // 出让公告文件路径

            this.getPolicyInfo({
              county: data.county ? data.county : "",
              parkCode: data.parkCode ? data.parkCode : "",
            });
            // 查询出让公告和出让公示
            this.getCrggHtml();
            this.getCrgsHtml();
          }
        })
        .finally(() => {
          this.mapLoading = false;
        });
    },
    getPolicyInfo(params) {
      policyInfo(params).then((res) => {
        if (res.data.success) {
          this.policyInfos = res.data.data;
        }
      });
    },
    convert(args) {
      let param = args.map((item) => {
        switch (typeof item) {
          case "string":
            return `'${item}'`;
          case "object":
            return JSON.stringify(item);
          default:
            return `${item}`;
        }
      });
      return param;
    },
    skip(url) {
      if (url) {
        window.open(url);
      }
    },
    getFileIconUrl(fileSuffix) {
      let iconUrl;
      switch (fileSuffix) {
        case "pdf":
          iconUrl = require("@/assets/images/common/文件-pdf.png");
          break;
        case "doc":
        case "docx":
          iconUrl = require("@/assets/images/common/文件-word.png");
          break;
        case "zip":
        case "rar":
          iconUrl = require("@/assets/images/common/文件-压缩包.png");
          break;
        case "xls":
        case "xlsx":
          iconUrl = require("@/assets/images/common/excel.png");
          break;
        default:
          iconUrl = require("@/assets/images/common/文件-其它.jpg");
      }
      return iconUrl;
    },
    setSwiper() {
      let swiper = new Swiper(".mySwiper", {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      let swiper2 = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
        thumbs: {
          swiper: swiper,
        },
      });
    },
    scrollView(selector) {
      document.querySelector(selector).scrollIntoView();
    },
    previewOrDownFile(item) {
      let fileUrl = this.imgUrl + item.filePath; //所下载文件的网络地址
      const link = document.createElement("a");
      fetch(fileUrl)
        .then((res) => res.blob())
        .then((blob) => {
          // 将链接地址字符内容转变成blob地址
          link.href = URL.createObjectURL(blob);
          link.download = item.fileTitle; //下载成功后保存的文件名
          document.body.appendChild(link);
          link.click();
        });
      // item.filePath = this.imgUrl + item.filePath;
      // const link = document.createElement("a");
      // let blob = new Blob([item]);
      // let urlBold = URL.createObjectURL(blob);
      // link.href = urlBold;
      // link.download = item.fileName;
      // this.$message.success("下载成功");
      // link.click();
      // window.open(this.imgUrl + url);
    },
    goPark(id) {
      this.$router.push({ path: "/parkDetail", query: { id: id } });
    },

    //查看全景
    panorama(item) {
      window.open(item);
    },
    //播放视频
    playVideos(file) {
      this.playVideo.show = true;
      this.playVideo.src =
        systemConfig.imgServer + systemConfig.imgApi + file.filePath;
      this.playVideo.title = file.fileTitle || "";
    },
    //查看图片
    handleLook(list, index) {
      this.previewImage.urlList = [];
      list.forEach((item) => {
        this.previewImage.urlList.push(this.imgUrl + item.filePath);
      });
      this.previewImage.index = index;
      this.previewImage.show = true;
    },
    lookPdf(file) {
      window.open(systemConfig.imgServer + systemConfig.imgApi + file.filePath);
    },
    //跳转我要用地
    goMap() {
      sessionStorage.setItem(
        "landInfoDetail",
        JSON.stringify({
          name: this.landDetailData.name,
          id: this.landDetailData.id,
          type: "land",
        })
      );
      this.$router.push({
        path: "/needLand/indexCopy",
      });
    },
    // 获取出让公告
    getCrggHtml() {
      let code = this.landDetailData.code;
      if (code) {
        transferAnnouncement(code).then((res) => {
          if (res.data.success) {
            this.crggHtml = res.data.data.content;
          } else {
            this.crggHtml = "";
          }
        });
      } else {
        this.crggHtml = "";
      }
    },
    // 获取出让公示
    getCrgsHtml() {
      let code = this.landDetailData.code;
      if (code) {
        plotPublicity(code).then((res) => {
          if (res.data.success) {
            this.crgsHtml = res.data.data.content;
          } else {
            this.crgsHtml = "";
          }
        });
      } else {
        this.crgsHtml = "";
      }
    },
  },
  updated() {
    // this.$nextTick(() => {
    //   console.log(this.$refs.r1.clientHeight);
    //   this.$refs.l1.style.height = this.$refs.r1.clientHeight + 10 + "px";
    // });
  },
};
</script>

<style scoped>
.park-detail {
  padding: 10px;
  width: calc(60% - 20px);
  margin: 0 auto;
  background: white;
  position: relative;
}

.intention-box {
  position: absolute;
  right: -80px;
  top: 120px;
}

.park-detail-title {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #e0e0e0;
  padding: 4px 2px 4px 0;
}

.park-detail-title-text {
  font-size: 1rem;
  font-weight: 600;
  flex-grow: 1;
}

.park-detail-title-browse-count {
  font-size: 0.75rem;
  color: #8a8a8a;
  align-self: flex-end;
  flex-shrink: 0;
}

.park-detail-base {
  display: flex;
  column-gap: 20px;
}

.park-detail-base .disclaimer {
  font-size: 0.75rem;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.park-detail-base .disclaimer span:first-child {
  color: red;
  font-size: 0.95rem;
}

.disclaimer-btn {
  font-size: 0.95rem;
  height: 35px;
  padding: 0 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
}

.disclaimer-btn1 {
  background: #ff9900;
}

.disclaimer-btn2 {
  background: #169bd5;
}

.disclaimer-btn3 {
  background: #999999;
  color: #fff;
}

.disclaimer-icon {
  margin-left: 10px;
  font-size: 1.25rem;
  color: rgb(255, 55, 0);
  display: flex;
  align-items: center;
}

.park-detail-base-img {
  width: 50%;
  height: 420px;
}

.park-detail-base-content {
  width: 50%;
  /* display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px 10px;
  font-size: 0.85rem; */
}

.park-detail-base-content-li {
  width: 100%;
}

.park-detail-base-content-li-t {
  font-size: 0.85rem;
  font-weight: 600;
  color: #04469b;
  margin: 7px 0;
  display: flex;
}

.park-detail-base-content-li-c {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.park-detail-base-content-li-c-li {
  display: flex;
  justify-content: space-between;
  margin: 3px 0;
}

.park-li-1 {
  width: 100%;
}

.park-li-2 {
  width: calc((100% - 14px) / 2);
}

.li-1 {
  width: 100px;
  font-size: 0.8rem;
  background: #edf5fe;
  color: #393939;
  display: flex;
  align-items: center;
  justify-content: center;
}

.span-content {
  padding: 6px 0;
  text-align: center;
}

.li-2 {
  width: calc(100% - 110px);
  font-size: 0.75rem;
  border: 1px solid #edf5fe;
}

.li-3 {
  width: calc((100% - 220px) / 2);
}

.park-detail-base-content-price {
  /* grid-column: 1 / -1; */
  height: 50px;
  padding: 0 4px;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.park-detail-base-content-price-text {
  font-weight: bold;
  font-size: 1rem;
  color: #0054bb;
  display: flex;
  align-items: center;
}

.go-map {
  margin-left: 5px;
  cursor: pointer;
}

.park-detail-base-content-price-span {
  font-size: 0.75rem;
  color: #837a7a;
}

.park-detail-base-content-price-img {
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #0054bb;
  font-size: 0.8rem;
  cursor: pointer;
}

/*.park-detail-base-content-info {
}

.park-detail-base-content-info-key {
}

.park-detail-base-content-info-value {
} */

.park-detail-top-title1 {
  display: flex;
  justify-content: space-between;
}

.park-detail-top-title1-l {
  font-weight: bold;
  font-size: 1rem;
  color: #0054bb;
  display: flex;
  align-items: center;
}

.park-detail-top-title1-r {
  display: flex;
}

.park-detail-top-title1-r-img {
  width: 30px;
  height: 30px;
  margin: 0 5px;
  /*background: #e6effb;*/
  padding: 2px 5px;
  border-radius: 3px;
  cursor: pointer;
}

.park-detail-top-title1-r-img > img {
  width: 100%;
  height: 100%;
}

.park-detail-top-title2 {
  display: flex;
  margin: 3px 0;
}

.park-detail-top-title2-li {
  font-size: 0.8rem;
  font-weight: 600;
  color: #4d4d4d;
  padding: 0 10px;
  border-right: 1px solid rgb(160, 160, 160);
}

.park-detail-top-title2-li:first-child {
  padding: 0 10px 0 0;
}

.park-detail-top-title2-li:last-child {
  border-right: none;
}

.park-detail-top-title3 {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.park-detail-top-title3-li1 {
  border-radius: 4px;
  /* background: #ff4c4c; */
  color: #fff;
  text-align: center;
}

.park-detail-top-title3-li2 {
  /*width: 100px;*/
  min-width: 100px;
  padding: 0 10px;
  height: 28px;
  /*border-radius: 50%;*/
  background: #01ba61;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  box-sizing: border-box;
  margin: 10px 5px;
}

.park-detail-top-title3-li2-span1 {
  font-size: 0.8rem;
}

.park-detail-top-title3-li2-span2 {
  font-size: 0.75rem;
}

.park-detail-top-title3-span1 {
  text-align: center;
  align-items: center;
  font-size: 0.85rem;
  width: 100px;
  height: 28px;
  /*font-weight: 600;*/
  /*padding: 5px;*/
  line-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 5px;
}

.park-detail-top-title3-li3 {
  width: 100%;
  padding: 10px;
  margin-right: 10px;
  display: flex;
  background: #617fd0;
  color: #ffffff;
  font-size: 0.8rem;
  align-items: center;
  text-align: right;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.park-detail-top-title4 {
  /* display: grid;
  grid-template-rows: 50% 50%;
  grid-template-columns: 33% 33% 33%; */
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0;
}

.park-detail-top-btn {
  font-size: 0.75rem;
  color: #fff;
  background: #50b3e3;
  padding: 4px 15px;
  border-radius: 4px;
  width: max-content;
  cursor: pointer;
  margin-top: 15px;
}

.park-detail-top-title4-li {
  height: 40px;
  width: 33%;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}

.park-detail-top-title4-li-t {
  font-size: 0.75rem;
  color: #979595;
}

.park-detail-top-title4-li-b {
  padding-top: 5px;
  font-size: 0.8rem;
  color: #292929;
  width: 100%;
  /* font-weight: 600; */
}

.park-detail-top-title5 {
  display: flex;
  /*margin-top: 30px;*/
  flex-wrap: wrap;
}

.park-detail-top-title5-span {
  width: 100px;
  /*padding: 5px 0;*/
  text-align: center;
  line-height: 28px;
  color: #fff;
  font-weight: 600;
  font-size: 0.8rem;
  border-radius: 4px;
  margin: 10px 5px;
}

.title5-span1 {
  background: #2fc2ff;
}

.title5-span2 {
  margin-left: 5px;
  background: #01ba61;
}

/* .park-detail-top-title5-span2 {
  padding: 5px 10px;
  background: #01ba61;
} */
.info-value-bold {
  font-weight: bold;
}

.info-value-text1 {
  color: #0064fd;
}

.info-value-text2 {
  color: #317dfc;
  font-size: 0.75rem;
}

.info-value-text3 {
  color: #717171;
}

.flex-box {
  display: flex;
  align-items: center;
}

.into-park {
  /* width: 100px; */
  padding: 2px 10px;
  margin-left: 10px;
  background: #c2f0cf;
  border-radius: 10px;
  color: #00b147;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.grid-single-line {
  grid-column: 1 / -1;
}

.park-detail-info {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  column-gap: 20px;
}

.park-detail-info-content-nav {
  display: grid;
  grid-template-columns: repeat(3, 1fr) 2fr;
  background-color: #f4f4f4;
  padding: 2px;
  cursor: pointer;
}

.park-detail-info-content-nav-item {
}

.park-detail-info-sub-title {
  margin-top: 20px;
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}

.park-detail-info-content {
}

.park-detail-info-investment-content > div {
  border: solid 1px #e0e0e0;
}

.park-detail-info-investment-video {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-video-item-thumbnail {
  width: 120px;
  height: 80px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.park-detail-info-investment-video-item-thumbnail-img {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
}

.park-detail-info-investment-video-item-thumbnail-action {
  grid-column: 2 / 3;
  grid-row: 2 /3;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  color: white;
}

.park-detail-info-investment-video-item-title {
}

.park-detail-info-investment-image {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-image-item-img {
  width: 120px;
  height: 80px;
}

.park-detail-info-investment-image-item-title {
}

.park-detail-info-investment-file {
  /*margin-top: 10px;*/
  /*display: flex;*/
  /*flex-wrap: wrap;*/
  /*gap: 10px;*/
  /*border: solid 1px #e5e5e5;*/
}

.park-detail-info-investment-file-item-img {
  width: 120px;
  height: 80px;
  padding: 8px 28px;
  box-sizing: border-box;
  filter: grayscale(1);
}

table {
  border: solid 1px #d0d0d0;
  border-spacing: 0;
  border-collapse: collapse;
}

.park-detail-table {
  width: 100%;
  text-align: center;
}

.park-detail-table-header {
  background-color: #e6efff;
  color: #105ab5;
  font-weight: 600;
  font-size: 1rem;
  padding: 12px;
}

.park-detail-table-key {
  width: calc(100% / 6);
  padding: 8px;
  color: #000000;
}

.park-detail-table-value {
  color: #858585;
  width: calc(100% / 6 * 2);
  padding: 8px;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 1.12rem;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  height: calc(100% / 9 * 7);
  width: 100%;
}

.mySwiper {
  height: calc(100% / 9 * 2);
  box-sizing: border-box;
  padding: 5px 0;
}

.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-slide-icon {
  position: absolute;
  color: #fff;
  font-size: 1.55rem;
}

.swiper-slide-title {
  position: absolute;
  top: 10px;
  left: 5px;
  font-size: 0.85rem;
  /* font-weight: 600; */
  color: #fff;
  padding: 3px 5px;
  border-radius: 4px;
  background: #00000059;
  /* 设置描边宽度及颜色 默认为字体内外描边 */
  /* text-stroke: 1px #fff; */
  /* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
  /* -webkit-text-stroke: 1px #fff; */
}

.m-swiper-button {
  --swiper-navigation-size: 14px;
  color: white;
  background-color: #00000073;
  width: 20px;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
}

.park-detail-info-investment-file-li {
  padding: 5px 0;
  cursor: pointer;
  color: #0a75da;
  font-size: 0.85rem;
}

>>> .tz-toggle-layout__warp {
  z-index: 1000 !important;
}

.other-box-l-li1 {
  /* margin-top: 20px; */
  width: 100%;
}

::v-deep .table-detail table {
  width: 100%;
}

/deep/ .table-detail {
  /*font-size: 0.85rem;*/
}

/*
::v-deep .table-detail tr {
  border-collapse: collapse;
  text-align: center;
  font-size: 0.85rem;
} */
.other-box-l-li2 {
  margin-top: 20px;
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
  /* max-height: 360px; */
}

.other-box-l-li-p {
  font-size: 0.85rem;
  font-weight: 500;
  margin-left: 30px;
  cursor: pointer;
}

.other-box-title {
  color: #0054bb;
  font-size: 0.85rem;
  font-weight: bold;
  border-left: 5px solid;
  padding-left: 5px;
}

.other-box-l-li-p-box {
  display: flex;
}

.other-box-l-li-p-content {
  width: calc(100% - 320px);
  /* padding: 10px 0; */
  line-height: 25px;
  font-size: 0.85rem;
  max-height: 305px;
  overflow: auto;
}

.other-box-l-li-p-gd {
  width: 360px;
  /* position: absolute;
  bottom: 0px;
  right: 10px; */
  /* font-size: 0.85rem;
  font-weight: 600;
  color: #045dff;
  background: #bdd7ed82;
  padding: 2px 10px;
  border-radius: 4px;
  cursor: pointer; */
}

.other-box-l-li-p-gd-t {
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-template-rows: 50% 50%;
  flex-wrap: wrap;
  justify-content: center;
}

.other-box-l-li-p-gd-t-img {
  padding: 2px;
  height: 70px;
  cursor: pointer;
}

.other-box-l-li-p-gd-t-img > img {
  width: 100%;
  height: 100%;
}

.other-box-l-li-p-gd-b {
  position: relative;
  padding: 5px 2px;
  height: 150px;
  cursor: pointer;
}

.other-box-l-li-p-gd-b > img {
  width: 100%;
  height: 100%;
}

.other-box-l-li-p-gd-b-icon {
  position: absolute;
  top: calc((100% - 30px) / 2);
  left: calc((100% - 30px) / 2);
  font-size: 1.9rem;
  color: #fff;
}

.other-box-l-li-text {
  width: 200px;
  color: #495eb8;
  font-weight: 600;
  font-size: 1.12rem;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  padding: 12px 10px;
}

.other-box-l-li-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  /* padding: 10px 0 0 0; */
}

.other-box-l-li-box1 {
  column-count: 2;
  column-gap: 10px;
  /* display: flex;
  flex-wrap: wrap;
  justify-content: space-between; */
  width: 100%;
  padding: 10px 0 0 0;
}

.other-box-l-li-box2 {
  width: calc(100% - 20px);
  height: 425px;
  margin-left: 20px;
  /* max-height: 425px; */
  display: flex;
  margin: auto;
  justify-content: center;
}

.other-box-l-li-box2 > img {
  /* margin: auto; */
  /* width: 100%;
  height: 100%; */
}

.other-box-l-li-box-li {
  width: 48%;
  line-height: 30px;
  display: flex;
}

.other-box-d {
  /* 解决瀑布流因高度改变而溢出*/
  height: 100%;
  overflow: auto;
  margin-bottom: 15px;
}

.other-box-l-li-box-li1 {
  line-height: 30px;
  text-align: center;
  border: 1px solid #357ad7;
  border-radius: 4px;
}

.other-box-l-li-box-li-r {
  font-size: 0.85rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.active-box {
  background: #357ad7;
  color: #fff;
}

.other-box-l-li-box-li-r1 {
  font-size: 0.85rem;
  margin-top: 10px;
  height: 37px;
  width: calc(100% - 20px);
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 10px;
}

/* .other-box-r-content {
  padding: 10px 0;
  line-height: 26px;
  font-size: 0.85rem;
} */
.other-box-r-content {
  background: #ecfbff;
  color: #494949;
  /* width: max-content; */
  padding: 6px 20px 6px 10px;
  font-size: 0.8rem;
  border-radius: 15px;
  margin-top: 15px;
  border: 1px solid #ebf0f1;
}

.other-box-r-content-tag {
  color: #1a9af5 !important;
  font-size: 1rem;
  padding-right: 5px;
}

.other-box-r-box {
  margin-top: 20px;
  display: flex;
  /* justify-content: space-between; */
  /* grid-template-columns: 30% 30% 30%;
  grid-template-rows: 85px 85px 85px; */
}

.other-box-r-box-li {
  display: flex;
  flex-direction: column;
  /* margin: auto; */
  width: 75px;
}

.other-box-r-box-li-t {
  width: 33px;
  height: 33px;
  margin: 0 auto;
}

.other-box-r-box-li-t > img {
  width: 100%;
  height: 100%;
}

.other-box-r-box-li-b {
  height: calc(100% - 43px);
  margin-top: 5px;
  font-size: 0.8rem;
  text-align: center;
  color: #504949;
}

.panorama-box {
}

.panorama-box-title {
  /* color: #363636; */
  color: #0054bb;
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 2px;
}

.panorama-box-li {
  padding: 6px 0;
  font-size: 0.8rem;
  /* border-bottom: 1px dotted #bbb3b3; */
  border-bottom: 1px dotted #8abadd;
  display: flex;
  justify-content: space-between;
  color: #0089ff;
  cursor: pointer;
  align-items: center;
}

.panorama-box-li > span {
  color: #0089ff;
}

.panorama-box-li:last-child {
  border-bottom: none;
}

.detail-pop-content-box {
  font-size: 0.8rem;
}

.detail-pop-content-box-title {
  display: flex;
  align-items: center;
  margin: 10px 0;
  color: #000;
  font-size: 0.85rem;
  font-weight: bold;
}

.detail-pop-content-box-title-span {
  padding-left: 5px;
}

.detail-pop-content-box-title-span span {
  color: red;
  font-size: 0.75rem;
  display: inline-block;
  margin-left: 15px;
}

.detail-pop-content-box-col {
  padding: 10px 0;
  word-break: break-all;
  color: #000000;
}

.detail-pop-content-box-col-c {
  max-height: 400px;
  overflow: auto;
}

::v-deep .detail-pop-content-box-col-c > p,
span {
  line-height: 22px;
  margin: 0;
  /*color: #363636;*/
}

::v-deep .detail-pop-content-box-col-c > p > img {
  width: 100%;
  height: 100%;
}

.mask {
  width: 65px;
  height: 65px;
  font-size: 0.95rem;
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 0;
  opacity: 0;
  background: rgba(4, 20, 41, 0.4);
  border-radius: 4px;
  line-height: 65px;
  /* padding: 24px 0; */
}

.img-list {
  width: 65px;
  height: 85px;
  margin-right: 10px;
  cursor: pointer;
}

.img-list-box {
  display: flex;
  flex-wrap: wrap;
}

.img-span {
  font-size: 0.75rem;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.img-list > img {
  width: 100%;
  height: 65px;
  border-radius: 4px;
  overflow: hidden;
}

.img-list1 {
  position: relative;
  width: 65px;
  height: 85px;
  margin-right: 10px;
}

.img-list1:hover .mask {
  opacity: 1;
  cursor: default;
}

.img-list1 > img {
  width: 100%;
  height: 65px;
  border-radius: 4px;
  overflow: hidden;
}

.attachments {
  /*color: #495eb8;*/
  font-weight: 600;
  font-size: 0.85rem;
  padding: 12px 0px;
  color: #1e63b9;
  border-bottom: 1px dashed #e5e5e5;
}

.traffic-location {
  height: 720px;
  width: 100%;
}

.traffic-location-top {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 40px;
}

.traffic-location-top-left {
  font-size: 0.95rem;
  font-weight: 600;
}

.traffic-location-top-right {
  display: flex;
  font-size: 0.85rem;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 0px 6px 1px #eee;
}

.traffic-location-top-right-li {
  padding: 5px 10px;
  cursor: pointer;
}

.right-li-active {
  background: #3692fc;
  color: #fff;
}

.traffic-location-map {
  height: calc(100% - 40px);
  width: 100%;
}

.content-tab {
  margin-top: 20px;
}

::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  border: none !important;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  color: #0054bb;
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  border-bottom: none !important;
}

::v-deep .el-tabs--border-card {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .el-tabs__item {
  font-weight: 600;
  font-size: 1rem;
  padding: 0 32px;
}

::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: 15px 0;
}

/deep/ .el-tabs__content {
  min-height: 400px;
}

.availableNear {
  background: rgb(73, 122, 255);
}

.available {
  background: rgb(2, 214, 74);
}

.availability {
  background: #f5a702;
}

/deep/ .develop-style {
  font-size: 0.85rem;
  cursor: pointer;
  color: #1446a6;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eaeefb;
  padding: 10px;
}

#dom {
  height: 350px;
  overflow: hidden;
  padding: 10px;
}

#dom2 {
  height: 350px;
  overflow: hidden;
  padding: 10px;
}

/deep/ table.quill-better-table {
  font-size: 0.75rem;
}

::v-deep .el-dialog__body {
  padding: 0px 20px 30px;
}

::v-deep .el-dialog__title {
  color: #004adf;
  font-weight: bold;
}

.unavailable {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}

.col-box {
  display: flex;
  line-height: 20px;
}

.col-r {
  width: calc(100% - 130px);
  margin-left: 10px;
  line-height: 20px;
  display: flex;
  flex-wrap: wrap;
}

.col-r > div {
  width: 50%;
}

>>> .el-image-viewer__img {
  width: 800px;
  height: 500px;
}
</style>
